import FormatTime from 'components/FormatTime';
import { StyledDurationContainer } from './styled';

type PropsType = {
  duration: number;
};

const DurationSection = ({ duration }: PropsType) => (
  <StyledDurationContainer>
    <FormatTime time={duration / 1000} />
  </StyledDurationContainer>
);

export default DurationSection;
